import { gql } from "@apollo/client";
import { ATTRIBUTE_FIELDS } from "../fragments";

export const ATTRIBUTE_CREATE = gql`
  ${ATTRIBUTE_FIELDS}
  mutation AttributeCreate($data: AttributeCreateInput!, $gameId: String!) {
    attributeCreate(gameId: $gameId, data: $data) {
      ...AttributeFields
    }
  }
`;

export const ATTRIBUTE_DELETE = gql`
  ${ATTRIBUTE_FIELDS}
  mutation AttributeDelete($attributeId: String!) {
    attributeDelete(attributeId: $attributeId) {
      ...AttributeFields
    }
  }
`;

export const ATTRIBUTE_UPDATE = gql`
  ${ATTRIBUTE_FIELDS}
  mutation AttributeUpdate($data: AttributeUpdateInput!, $attributeId: String!) {
    attributeUpdate(attributeId: $attributeId, data: $data) {
      ...AttributeFields
    }
  }
`;
